import React from 'react'

import { PartsType } from '../../data/consts';
import { useSelectedParts } from '../../context/AppContext';
import { useTheme } from '../../context/ThemeContext';

import Parts from '../organism/Parts';
import "../../style/Preview.css"

const Preview = () => {
  //useSelectedPartsの最初の中身は [PartsType.Hair]: PartsID.DefaultHair,
  const selectedParts = useSelectedParts();
  const { color } = useTheme()

  return (
    <>
      <div
        className='preview-view'
        id='target-component'
        style={{ background: color }}
      >
        <Parts type={PartsType.Hair} id={ selectedParts[PartsType.Hair] }/>
        <Parts type={PartsType.Eyebrow} id={ selectedParts[PartsType.Eyebrow] } />
        <Parts type={PartsType.Eyes} id={ selectedParts[PartsType.Eyes] } />
        <Parts type={PartsType.Nose} id={ selectedParts[PartsType.Nose] } />
        <Parts type={PartsType.Mouth} id={ selectedParts[PartsType.Mouth] } />
        <Parts type={PartsType.Glasses} id={ selectedParts[PartsType.Glasses] } />
        <Parts type={PartsType.Other} id={ selectedParts[PartsType.Other]}/>
      </div>
    </>
  )
}


export default Preview
